import TitledPanel from "./TitledPanel";

export default TitledPanel;
